// extracted by mini-css-extract-plugin
export default {"screen":"GlossaryEdit_screen__cRcAN"};